import React from 'react';
import classes from './Messages.module.scss';
import { useTranslation } from 'react-i18next';
import { GroupedVirtuosoHandle } from 'react-virtuoso';

type AwaitingMessageProps = {
  bodyRef: React.RefObject<GroupedVirtuosoHandle>
}
const AwaitingMessage = ({bodyRef}: AwaitingMessageProps) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    bodyRef.current?.scrollToIndex({ index: 'LAST', behavior: 'smooth' })
  },[])
  
  return (
    <div className={classes.thinking1}>
      <span className={classes.text}>{t('Chats.selectAI.thinking')}</span>
      <span className={classes.dots}>
        <span className={classes.dot}></span>
        <span className={classes.dot}></span>
        <span className={classes.dot}></span>
      </span>
     </div>
  );
}

export default AwaitingMessage;
